<template>
  <div class="main">
    <topImg title="用创新的教与学服务每个人" desc="在元宇宙时代探索和认知世界" img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/news/banner_news.png"></topImg>
    <div class="content">
      <div class="newHead">
        <img :src="significance.thumb" class="newImg" />
        <div class="newContent">
          <div class="newTitle">{{ significance.title }}</div>
          <span class="time">{{ significance.inputtime }}</span>
          <div class="newDesc">
            {{ significance.description }}
          </div>
          <span class="newDetail" @click="goDetail(significance.id)">查看详情</span>
        </div>
      </div>
      <div id="pageChange"></div>
      <div class="newList" v-if="currentPage === 1">
        <div class="new" v-for="item in arr" :key="item.id">
          <div class="bgimg">
            <img v-lazy="item.thumb" :key="item.thumb">
          </div>
          <div class="newTitle">{{ item.title }}</div>
          <div class="time">{{ item.inputtime }}</div>
          <div class="desc">{{ item.description }}</div>
          <span class="detail" @click="goDetail(item.id)">详情 ></span>
        </div>
      </div>
      <div class="newList bottomList">
        <div class="new" v-for="item in list" :key="item.id">
          <div class="bgimg">
            <img v-lazy="item.thumb" :key="item.thumb">
          </div>
          <div class="newTitle">{{ item.title }}</div>
          <div class="time">{{ item.inputtime }}</div>
          <div class="desc">{{ item.description }}</div>
          <span class="detail" @click="goDetail(item.id)">详情 ></span>
        </div>
      </div>
      <div class="pagination" v-if="list.length > 0" id="isPCF">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync='currentPage'
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="total">
        </el-pagination>
      </div>
      <!-- <div class="pagination" id="isPCF">
        <div class="desc">
          <span>当前第 </span>
          <span>{{currentPage}}</span>
          <span> 页，共 {{ pageTotal }} 页，共 {{ total }} 条</span>
        </div>
        <el-pagination
          layout="prev, pager, next"
          :current-page.sync='currentPage'
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination>
      </div> -->
      <van-pagination id="isMobileF" class="paginationMobile" @change='handleCurrentChange'  v-model="currentPage" :total-items="total" items-per-page='6' />
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Pagination } from 'vant';
import { newsList } from '@/services/api'

Vue.use(Pagination);

export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageTotal: 0,
      pageSize: 6,
      arr: [],
      significance: {},
      list: []
    };
  },
  created() {
    this.getData()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      if (val !== 1) {
        this.pageSize = 6
      }
      window.location.href = '#pageChange'
      this.getData()
    },
    getData() {
      let data = {
        page: this.currentPage,
        page_size: 6,
        status: 0
      }
      newsList(data).then(res => {
        if (this.currentPage === 1) {
          this.significance = res.data.show_top
          this.arr = res.data.show_index
          this.total = res.data.total
        }
        this.list = res.data.list
      })
    },
    goDetail(id) {
      this.$router.push({
        name: 'newsDetail',
        query: {
          id
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
#pageChange{
  position: relative;
  top: -80px;
}
.main {
  background: #fff;
  .content{
    width: 1200px;
    margin: 0 auto;
    .newHead{
      width: 100%;
      height: 473px;
      margin-top: 0.8rem;
      margin-bottom: 50px;
      display: flex;
      border-radius: 8px;
      overflow: hidden;
      justify-content: space-between;
      background: url('https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/8b66dc0d13c4aa8b313ec8221b8ac128.png');
      .newImg{
        width: 59%;
        height: 100%;
        background: url('');
      }
      .newContent{
        width: 41%;
        padding: 67px 30px;
        .newTitle{
          width: 398px;
          font-size: 22px;
          font-weight: 550;
          line-height: 30px;
        }
        .time{
          font-size: 14px;
          color: #8D8E9D;
          letter-spacing: 0;
          font-weight: 400;
          margin-top: 12px;
        }
        .newDesc{
          font-size: 14px;
          margin-top: 24px;
          height: 114px;
          color: #000;
          line-height: 38px;
        }
        .newDetail{
          width: 150px;
          height: 50px;
          color: #fff;
          font-size: 16px;
          margin-top: 30px;
          display: inline-block;
          line-height: 50px;
          text-align: center;
          background-color: #F27529;
          border-radius: 25px;
          cursor: pointer;
        }
      }
    }
    .newList.bottomList{
      margin: 0;
    }
    .newList{
      width: 100%;
      margin-top: 50px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      .new{
        width: 31.6666%;
        height: 530px;
        margin-bottom: 50px;
        border-top-left-radius: 19px;
        border-top-right-radius: 19px;
        margin-right: 30px;
        .bgimg{
          width: 100%;
          height: 263px;
          margin-bottom: 21px;
          border-top-left-radius: 19px;
          border-top-right-radius: 19px;
          img{
            width: 100%;
            height: 263px;
            border-top-left-radius: 19px;
            border-top-right-radius: 19px;
            object-fit: cover;
          }
        }
        .newTitle{
          color: #000;
          height: 60px;
          font-size: 22px;
          font-weight: 550;
          line-height: 30px;
          padding: 0 13px;
          overflow: hidden;
          margin-bottom: 21px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }
        .time{
          color: #6B738C;
          font-size: 14px;
          padding: 0 13px;
          margin-bottom: 18px;
        }
        .desc{
          height: 66px;
          color: #000;
          font-size: 14px;
          line-height: 22px;
          padding: 0 13px;
          overflow: hidden;
          margin-bottom: 22px;
        }
        .detail{
          width: 86px;
          height: 32px;
          color: #F27529;
          font-size: 12px;
          border-radius: 16px;
          // display: inline-block;
          // line-height: 29px;
          // text-align: center;
          padding-top: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 13px;
          border: 1px solid #F27529;
          cursor: pointer;
        }
      }
      .new:nth-child(3n) {
        margin-right: 0;
      }
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
      color: #fff;
      border: 0;
      background: #F27529 !important;
    }
    .title{
      font-size: 42px;
      font-weight: bold;
      color: #767676;
      line-height: 1;
      margin-top: 50px;
    }
    .nopx-line{
      width: 71px;
      height: 1px;
      border: 1px solid #FDD917;
      margin-top: 10px;
    }
    .list{
      width: 100%;
      height: 190px;
      display: flex;
      border-bottom: 1px solid rgba(151, 151, 151, .25);
      padding: 33px 0;
      box-sizing: content-box;
      > img{
        width: 254px;
        height: 190px;
        display: block;
      }
      .right{
        padding-left: 22px;
        flex: 1;
        .headline{
          font-size: 26px;
          font-weight: 500;
          color: #000000;
          line-height: 39px;
        }
        .desc{
          font-size: 22px;
          font-weight: 400;
          color: #64676C;
          line-height: 29px;
          margin-top: 16px;
          min-height: 102px;
        }
        .detail{
          span{
            font-size: 14px;
            font-weight: 400;
            color: #9EA7B3;
            line-height: 13px;
            padding-right: 57px;
          }
          .goDetail{
            cursor: pointer;
          }
        }
      }
    }
    .pagination{
      display: flex;
      // justify-content: space-between;
      justify-content: center;
      align-items: center;
      margin-top: 33px;
      padding-bottom: 100px;
      .desc{
        span{
          color: #666666;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
        span:nth-child(2){
          color: #f27529;
        }
      }
      /deep/ .el-pager li.active {
          color: #f27529;
          cursor: default;
      }
      /deep/ .el-pager li:hover {
          color: #f27529;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    padding-bottom: 100px;
    .content{
      width: 100%;
      padding: 0 48px;
      box-sizing: border-box;
      .newHead{
        width: 100%;
        height: auto;
        flex-direction: column;
        margin-top: 40px;
        margin-bottom: 30px;
        border-radius: 12px;
        .newImg{
          width: 100%;
          height: 280px;
          object-fit: cover;
        }
        .newContent{
          width: 100%;
          padding: 30px 24px;
          .newTitle{
            width: 100%;
            font-size: 30px;
            line-height: 44px;
          }
          .time{
            font-size: 22px;
            display: block;
            margin-top: 12px;
          }
          .newDesc{
            font-size: 24px;
            line-height: 36px;
            height: auto;
            margin-top: 16px;
          }
          .newDetail{
            width: 130px;
            height: 60px;
            font-size: 26px;
            line-height: 60px;
            margin-top: 24px;
            border-radius: 30px;
          }
        }
      }
      .newList{
        flex-direction: column;
        margin-top: 20px;
        .new{
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 40px;
          .bgimg{
            height: 240px;
            img{
              height: 240px;
            }
          }
          .newTitle{
            height: auto;
            font-size: 30px;
            -webkit-line-clamp: 2;
            margin-bottom: 16px;
            line-height: 44px;
          }
          .time{
            font-size: 22px;
            margin-bottom: 14px;
          }
          .desc{
            height: auto;
            font-size: 24px;
            line-height: 36px;
            margin-bottom: 16px;
          }
          .detail{
            width: 100px;
            height: 48px;
            font-size: 22px;
            border-radius: 24px;
          }
        }
        .new:nth-child(3n){
          margin-right: 0;
        }
      }
      .paginationMobile{
        width: 90%;
        margin: 0 auto;
      }
      /deep/ .van-pagination__item{
        color: #F27529;
      }
      /deep/ .van-pagination__item--active{
        color: #fff;
        background: #f27529;
      }
    }
  }
}
</style>
